<template>
    <!--portal to="mobile-root"-->
    <div class="before-inspection-modal-container pe-none" :open="showBackdrop">
        <transition name="fade">
            <div class="backdrop" @click="backdropClickHandler" v-if="showBackdrop"></div>
        </transition>
        <transition
            :name="currentTransition"
            mode="out-in"
        >
            <div :key="0" class="select-modal operation-modal" v-if="showModal && currentStage == 'operation'">
                <div class="select-modal-header">
                    <h3>Tipo de operação</h3>
                    <p class="mx-1 my-2 text-center">
                        Selecione um tipo de operação para continuar
                    </p>
                </div>

                <div class="my-3 container-select">
                    <button-select :list="operationList" @selected="selectOperation($event.id)"></button-select>
                </div>

                <footer class="modal-footer d-flex flex-row flex-nowrap">
                    <font-awesome-icon icon="exclamation-circle" class="help-icon text-muted" aria-hidden="true"></font-awesome-icon>
                    <p class="text-muted small">Apenas operações dos tipos base Entrega, Coleta e Cautelar estão disponíveis</p>
                </footer>
            </div>
            <div :key="1" v-else-if="showModal && currentStage == 'questionnaire'" class="select-modal questionnaire-modal">
                <div class="select-modal-header">
                    <h3>Questionário</h3>
                    <p class="mx-1 my-2 text-center">
                        Selecione um questionário para continuar
                    </p>
                </div>

                <div class="my-3 container-select">
                    <button-select :list="filteredQuestionnaires" @selected="selectQuestionnaire($event.id)"></button-select>
                </div>

                <footer class="modal-footer d-flex flex-row flex-nowrap">
                    <b-alert
                        :show='selectedOperation.parametros["nao_consultar_vistorias_api"]?.ativo'
                        class="m-0" variant="warning"
                        style="text-wrap: pretty; text-align: center;"
                    >
                        <div style="display: flex; align-items: center; gap: 0.5em;">
                            <font-awesome-icon icon="exclamation-circle" class="help-icon" size="xl" aria-hidden="true"></font-awesome-icon>
                            <small>
                                A consulta aos servidores de integração será ignorada pois o parâmetro de início de
                                nova vistoria sem consulta de dados está ativo para a operação selecionada na tela anterior
                            </small>
                        </div>
                    </b-alert>
                </footer>
            </div>
        </transition>
    </div>
    <!--/portal-->
</template>

<script>
import buttonSelect from "@/components/inspection/beforeInspection/buttonSelect.vue";
import { BAlert } from "bootstrap-vue";
import Swal from "sweetalert2";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faExclamationCircle);

const stages = {
    operation: "operation",
    questionnaire: "questionnaire",
};

export default {
    components: {
        "button-select": buttonSelect,
        "font-awesome-icon": FontAwesomeIcon,
        BAlert
    },
    data: function () {
        return {
            operationList: [],
            operations: [],
            questionnaires: [],
            selectedOperation: null,
            selectedQuestionnaire: null,
            filteredQuestionnaires: [],
            showModal: false,
            showBackdrop: false,
            closeOnBackdropClick: true,
            currentStage: stages.operation,
        };
    },
    computed: {
        currentTransition() {
            if(this.currentStage == stages.operation){
                return "bounce-in";
            } else {
                return "bounce-in-fade-out";
            }
        },
    },
    methods: {
        loadData () {
            this.operations = JSON.parse(localStorage.getItem("operations"))
                .filter(operation => operation.ativo == "1");

            this.questionnaires = JSON.parse(localStorage.getItem("quizzes"));

            this.operationList = this.generateOperationsList(this.operations);
        },
        selectOperation(item) {
            try {
                this.selectedOperation = this.operations.find(operation => parseInt(operation.id) === item);
                this.filteredQuestionnaires = this.generateQuestionnaireList(this.selectedOperation);
                this.currentStage = stages.questionnaire;
                this.closeOnBackdropClick = false;
                setTimeout(() => {
                    this.closeOnBackdropClick = true;
                }, 1);
            } catch (error) {
                console.error(error);
            }
        },
        selectQuestionnaire(questionnaireId) {
            // Encontrar o questionário selecionado na lista de todos os questionários
            this.selectedQuestionnaire = this.questionnaires.find(q => q.id == questionnaireId);

            this.saveOperation(this.selectedOperation);
            this.saveQuestionnaire(this.selectedQuestionnaire);
            
            this.$router.push({ path: "/inspection" });
            this.close();
        },
        saveOperation(operation){
            this.$store.commit("setOperation", operation);
        },
        saveQuestionnaire(questionnaire) {
            // Salvar os dados do questionário selecionado na store
            this.$store.commit("setQuizType", questionnaire.descricao);
            this.$store.commit("setQuizId", questionnaire.id);

            const questions = questionnaire.fields;

            this.$store.commit(
                "setQuizQuestions",
                questions.map((question) => {
                    return {
                        Avaria: "",
                        IdVistoria: 287,
                        Pergunta: {
                            Descricao: question.descricao,
                            Id: parseInt(question.id),
                            Avarias: question.avarias,
                        },
                        PerguntaEmpresa: {
                            Ativa: parseInt(question.ativa),
                            IdEmpresa: parseInt(question.idEmpresa),
                            IdQuestionario: parseInt(question.idQuestionario),
                            Obrigatorio: parseInt(question.obrigatorio),
                            Ordem: question.ordem ? parseInt(question.ordem) : 9999,
                            RespostaPadrao: question.respostaPadrao,
                        },
                        Resposta: null,
                    };
                })
            );

            let templates = [];
            const photosTemplates = JSON.parse(localStorage.getItem("photosTemplates"));
            const selectedTemplate = photosTemplates[questionnaire.id];
            selectedTemplate.forEach((item) => {
                const template = {
                    template_id: parseInt(item.id),
                    id: item.ordem,
                    ordem: item.ordem,
                    photoName: item.nomeArquivo,
                    image_name: item.nomeArquivo,
                    image_base64: item.urlArquivo,
                };
                templates.push(template);
            });
            this.$store.commit("setSelectedTemplate", templates);
        },
        generateOperationsList(operations) {
            const userGroupsEnabled = JSON.parse(localStorage.getItem("userGroupsEnabled"));

            let filteredOperations = operations;

            filteredOperations = operations.filter(operation => [1, 2, 5].includes(parseInt(operation.tipo_vistoria)));

            if(userGroupsEnabled) {
                const userGroupsIDs = JSON.parse(localStorage.getItem("userGroups")).map(ug => ug.id);

                filteredOperations = filteredOperations
                    .filter(operation =>{
                        const enabledUserGroups = operation.grupos_usuario.map(ug => parseInt(ug.id));
                        for(const id of userGroupsIDs){
                            if(enabledUserGroups.includes(id)){
                                return true;
                            }
                        }
                        return false;
                    });

                if(filteredOperations.length === 0) {
                    Swal.fire({
                        title: "Nenhum tipo de operação disponível",
                        text: "Não foi encontrado nenhum tipo de operação habilitado para os seus grupos de usuário",
                        icon: "warning",
                        showCancelButton: false,
                        confirmButtonColor: "#d33",
                        confirmButtonText: "Voltar",
                    });
                    return this.close();
                }
            }


            return filteredOperations.map((operation) => {
                return {
                    id: parseInt(operation.id),
                    title: operation.nome,
                    subtitle: operation.subtitulo,
                    help: {
                        title: "Exemplo de uso",
                        text: operation.exemplo_uso
                    }
                };
            });
        },
        generateQuestionnaireList(operation) {
            let enabledQuestionnaires = this.questionnaires
                .filter(questionnaire =>{
                    const questionnaireActive = questionnaire.status == "ATIVO";
                    const questionaireEnabledForOperation = operation.questionarios.map(op => op.id).includes(questionnaire.id);
                    return questionnaireActive && questionaireEnabledForOperation;
                });

            if(enabledQuestionnaires.length === 0){
                Swal.fire({
                    title: "Nenhum questionário disponível",
                    text: "Não foi encontrado nenhum questionário ativo habilitado para o tipo de operação selecionado",
                    icon: "warning",
                    showCancelButton: false,
                    confirmButtonColor: "#d33",
                    confirmButtonText: "Voltar",
                });
                return this.close();
            }

            return enabledQuestionnaires.map((questionnaire) => {
                return {
                    id: parseInt(questionnaire.id),
                    title: questionnaire.descricao,
                    subtitle: ""
                };
            });
        },
        close() {
            this.selectedOperation = null;
            this.selectedQuestionnaire = null;
            this.filteredQuestionnaires = [];
            this.currentStage = stages.operation,
            this.showBackdrop = false;
            this.showModal = false;
        },
        open() {
            this.showBackdrop = true;
            this.showModal = true;
            this.loadData();
        },
        backdropClickHandler() {
            if (this.closeOnBackdropClick) {
                this.close();
            }
        }
    }
};
</script>


<style scoped lang="scss">
    .fade-enter-active, .fade-leave-active {
        transition: opacity .1s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }

    .before-inspection-modal-container {
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 105;
        display: flex;
        pointer-events: none;

        * {
            pointer-events: auto; 
        }
    }
    .bounce-in-fade-out-enter-active {
        animation: bounce-in .25s ease;
    }
    .bounce-in-fade-out-leave-active {
        animation: none;
        transition: opacity .1s;
        opacity: 0;
    }

    .bounce-in-enter-active {
        animation: bounce-in .25s ease;
    }
    .bounce-in-leave, .bounce-in-leave-active {
        animation: none;
        display: none;
    }

    @keyframes bounce-in {
        0% {
            transform: scale(0.75);
        }
        60% {
            transform: scale(1.06);
        }
        100% {
            transform: scale(1);
        }
    }
    .backdrop {
        position: fixed;
        top: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0,0,0,.4);
        z-index: 100;
        cursor: pointer;
    }

    .select-modal {
        position: relative;
        margin: auto auto;
        box-shadow: 0 0 8px rgba(0,0,0,.4);
        z-index: 105;
        border: none;
        border-radius: 16px;
        width: 90vw;
        min-height: 200px;
        max-height: 80vh;
        padding: 10px 15px;
        background-color: white;
        display: flex;
        flex-direction: column;

        .container-select {
            overflow: scroll;
        }
    }

    .select-modal-header {
        h3 {
            color: var(--primary);
            margin-bottom: 0;
            padding-bottom: 10px;
            border-bottom: 1px solid #ccc;
        }

        p {
            background-color: #00d9ff31;
            font-size: 0.94em;
            padding: 2px;
        }
    }
</style>